export const helpers = {
  // Sum an array
  sum: arr => arr.reduce((acc, curr) => acc + curr, 0),

  // create an array of numbers between min and max (edges included)
  range: (min, max) => Array.from({ length: max - min + 1 }, (_, i) => min + i),

  // pick a random number between min and max (edges included)
  random: (min, max) => min + Math.floor(max * Math.random()),

  // Given an array of numbers and a max...
  // Pick a random sum (< max) from the set of all available sums in arr
  randomSumIn: (arr, max) => {
    const sets = [[]];
    const sums = [];
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0, len = sets.length; j < len; j++) {
        const candidateSet = sets[j].concat(arr[i]);
        const candidateSum = helpers.sum(candidateSet);
        if (candidateSum <= max) {
          sets.push(candidateSet);
          sums.push(candidateSum);
        }
      }
    }
    return sums[helpers.random(0, sums.length)];
  },

  // Format number to currency
  getCurrencyValue: (value, currency) => {
    let curCode = 'USD';
    let culture = 'en-US';
    if (currency && currency.startsWith('EU')) {
      curCode = 'EUR';
      culture = 'de-DE';
    }
    return new Intl.NumberFormat(culture, {
      style: 'currency',
      currency: curCode,
      minimumFractionDigits: 0
    }).format(value);
  }
};



// WEBPACK FOOTER //
// ./src/core/helpers.js